export default "__VITE_ASSET__DAkvvzHh__"